import React from 'react'
import { Helmet } from 'react-helmet';

export default function PageTitle({ title, description }) {
  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
    </Helmet>
  );
}
